import classnames from 'classnames';
import PropTypes  from 'prop-types';
import React      from 'react';


// The purpose of this component is to stop event bubbling in the button
// to prevent the keyboard from hiding when we submit a new message.
export default function ButtonWithoutPropagation({ onSubmit, disabled = false }) {

  function stopBubble(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function submit(event) {
    stopBubble(event);
    onSubmit();
  }

  const className = classnames('button', { disabled });

  return (
    <button
      className={className}
      onClick={stopBubble}
      onMouseDown={stopBubble}
      onTouchMove={stopBubble}
      onTouchStart={stopBubble}
      onTouchEnd={submit}
      onMouseUp={submit}
    >Send</button>
  );
}

ButtonWithoutPropagation.propTypes = {
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired
};
